import { useTranslation } from "react-i18next";
import { Icon } from "./icon/Icon";
import { useLocation, useNavigate } from "react-router";
// import Support from "../layout/settings/Support";
// import AddDeposit from "../layout/deposit/AddDeposit";
// import Withdrawal from "../layout/withdraw/Withdrawal";
import { useUserStore } from "@/modules/auth/store/user";
import WebApp from "@twa-dev/sdk";
import { useEffect } from "react";
import ClaimAirdrop from "../layout/airdrop/ClaimAirdrop";
import Nesting from "../layout/network/detailed/Nesting";
import { sendEvent } from "@/shared/utils/analytics/gtag";
import { AnalyticsEvents } from "@/shared/utils/analytics/events";
import { logger } from "@/shared/utils/logger";
import Support from "../layout/settings/Support";
import WithdrawalMatchingBonus from "../layout/matching-bonus/WithdrawalMatchingBonus";
// import Claim from "../layout/bonus/Claim";

type IconType =
  | "smile"
  | "link"
  | "settings"
  | "group-menu"
  | "sort-alphabetically";

interface MenuItem {
  label: string;
  icon: IconType;
  to: string[];
}

const analyticsMap: Record<
  string,
  { event: string; category: string; label: string }
> = {
  "/network": AnalyticsEvents.Network.Open,
  "/settings": AnalyticsEvents.Settings.Open,
  "/bonus": AnalyticsEvents.WeeklyBonus.Open,
  "/history": AnalyticsEvents.History.Open,
};

const Menu = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { activated } = useUserStore();
  const navigate = useNavigate();

  const isActive = (paths: string[]) => paths.includes(pathname);

  const menuItems: MenuItem[] = [
    {
      label: t("menu.main"),
      icon: "smile",
      to: ["/", "/deposit", "/withdraw", "/airdrop", "/my-deposits"],
    },
    {
      label: t("menu.network"),
      icon: "link",
      to: ["/network", "/network/detailed"],
    },
    {
      label: t("menu.history"),
      icon: "sort-alphabetically",
      to: ["/history"],
    },
    {
      label: t("menu.bonus"),
      icon: "group-menu",
      to: ["/bonus"],
    },
    {
      label: t("menu.settings"),
      icon: "settings",
      to: ["/settings", "/support"],
    },
  ];

  const coinsAudio = new Audio("/audio/coins.mp3");

  const handleClick = (to: string) => {
    if (activated === false) {
      return;
    }

    if (to === "/history") {
      coinsAudio.currentTime = 0;
      coinsAudio.play().catch((err) => {
        logger.warn("Audio playback failed:", err);
      });
    }

    const analytics = analyticsMap[to];
    if (analytics) {
      const { event, category, label } = analytics;

      sendEvent(event, {
        event_category: category,
        event_label: label,
      });
    }
    navigate(to);
  };

  useEffect(() => {
    const handleBackButtonClick = () => {
      navigate(-1);
    };

    const excludedPaths = ["/", "/network", "/settings"];
    const showBackButton = !excludedPaths.includes(pathname);

    if (showBackButton) {
      WebApp.BackButton.show();
      WebApp.BackButton.onClick(handleBackButtonClick);
    } else {
      WebApp.BackButton.hide();
      WebApp.BackButton.offClick(handleBackButtonClick);
    }

    return () => {
      WebApp.BackButton.hide();
      WebApp.BackButton.offClick(handleBackButtonClick);
    };
  }, [pathname, navigate]);

  return (
    <div
      className="fixed left-0 bottom-0 w-full bg-surface-primary border-t border-divider box-content"
      style={{ paddingBottom: "var(--tg-safe-area-inset-bottom)" }}
    >
      {pathname === "/settings" && <Support />}

      {/* {pathname === "/deposit" && <AddDeposit />} */}

      {/* TODO: Disabled due to maintenance */}
      {/* {pathname === "/withdraw" && <Withdrawal />} */}

      {pathname === "/matching-bonus" && <WithdrawalMatchingBonus />}

      {pathname === "/airdrop" && <ClaimAirdrop />}

      {pathname === "/network/detailed" && <Nesting />}

      {/* {pathname === "/bonus" && <Claim />} */}

      <div className="w-full flex items-center">
        {menuItems.map(({ label, icon, to }, index) => (
          <button
            onClick={() => handleClick(to[0])}
            key={index}
            className="shrink-0 flex-1 flex flex-col items-center pt-2 pb-1"
          >
            <Icon
              type={icon}
              className={`${
                isActive(to) ? "fill-link" : "fill-secondary-hint"
              } w-7 h-7`}
            />
            <p
              className={`${
                isActive(to) ? "text-link" : "text-secondary-hint"
              } text-[0.625rem] leading-[0.8125rem] font-semibold text-center`}
            >
              {label}
            </p>
          </button>
        ))}
      </div>
    </div>
  );
};

export default Menu;
